import { useState, useEffect } from 'react';
import { AlertTriangle, CheckCircle2, Ban } from 'lucide-react';
import api from '../../lib/api';

const addDays = (iso, n) => { const d = new Date(`${iso}T00:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString('sv-SE'); };
const short = (iso, el) => new Date(`${iso}T00:00:00`).toLocaleDateString(el ? 'el-GR' : 'en-GB', { weekday: 'short', day: 'numeric' });

// Shows how loaded the workshop is on the chosen day (+ next days) before booking
export const AvailabilityHint = ({ workshopId, date, excludeId, el }) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        if (!workshopId || workshopId === 'none' || !date) { setData(null); return; }
        api.get(`/leasing/workshops/${workshopId}/availability`, { params: { start: addDays(date, -1), days: 7, ...(excludeId ? { exclude_id: excludeId } : {}) } })
            .then((r) => setData(r.data)).catch(() => setData(null));
    }, [workshopId, date, excludeId]);
    if (!data) return null;
    const day = data.days.find((d) => d.date === date);
    if (!day) return null;
    const bad = day.closed || day.full;
    const Icon = day.closed ? Ban : day.full ? AlertTriangle : CheckCircle2;
    const text = day.closed ? (el ? 'Το συνεργείο είναι κλειστό αυτή τη μέρα.' : 'The workshop is closed on this day.')
        : day.full ? (el ? `Γεμάτη μέρα: ${day.booked}/${day.capacity} αυτοκίνητα. Μπορείτε να συνεχίσετε, αλλά το συνεργείο ίσως προτείνει άλλη ημερομηνία.` : `Full day: ${day.booked}/${day.capacity} cars. You can still book, but the workshop may propose another date.`)
        : day.capacity ? (el ? `Διαθέσιμο: ${day.booked}/${day.capacity} αυτοκίνητα κλεισμένα.` : `Available: ${day.booked}/${day.capacity} cars booked.`)
        : (el ? `${day.booked} ραντεβού αυτή τη μέρα.` : `${day.booked} bookings that day.`);
    return (
        <div className={`rounded-sm border px-3 py-2 text-sm space-y-2 ${bad ? 'border-amber-300 bg-amber-50 text-amber-800' : 'border-green-200 bg-green-50 text-green-800'}`} data-testid="maint-availability-hint">
            <p className="flex items-start gap-2" data-testid={bad ? 'availability-warning' : 'availability-ok'}><Icon className="w-4 h-4 mt-0.5 shrink-0" />{text}</p>
            <div className="flex gap-1 text-[11px]">
                {data.days.map((d) => (
                    <span key={d.date} className={`px-1.5 py-0.5 rounded-sm ${d.date === date ? 'ring-1 ring-current' : ''} ${d.closed ? 'bg-slate-200 text-slate-500' : d.full ? 'bg-red-100 text-red-700' : 'bg-white text-slate-600'}`} data-testid={`availability-day-${d.date}`}>
                        {short(d.date, el)}{d.closed ? ' ✕' : d.capacity ? ` ${d.booked}/${d.capacity}` : ''}
                    </span>
                ))}
            </div>
            {data.settings?.open_time && <p className="text-[11px] opacity-75">{el ? 'Ωράριο' : 'Hours'}: {data.settings.open_time}–{data.settings.close_time}</p>}
        </div>
    );
};
